



















import redirects from '@/constants/redirects.json';
import { TypeBody, BaseButton } from '@bambeehr/pollen';
import { useRouter, defineComponent, PropType } from '@nuxtjs/composition-api';

let callToActionLink: string = '';

const redirect = (link: string, router: any): void => {
  const redirectLink = redirects.find((item) => {
    callToActionLink = item.to;

    return item.from === link;
  });

  if (redirectLink) {
    window?.open(callToActionLink, '_blank');
  } else {
    router.push(link);
    window?.scrollTo(0, 0);
  }
};

export default defineComponent({
  name: 'CTABladeButton',
  components: {
    TypeBody,
    BaseButton,
  },

  props: {
    link: {
      type: String as PropType<string>,
      required: true,
      default: '',
    },
    text: {
      type: String as PropType<string>,
      required: true,
      default: 'See how we can help',
    },
  },

  setup(props) {
    const router = useRouter();

    const handleCTAButtonClick = (): void => {
      if (props.link !== '') {
        redirect(props.link, router);
      } else {
        router.push('/about');
      }
      window?.scrollTo(0, 0);
    };

    return {
      handleCTAButtonClick,
    };
  },
});
